import dayjs from 'dayjs';
import { atom } from 'recoil';

export type TGreaseTrapFilters = {
  vendorId?: string | null;
  vendorName?: string | null;
  vendorNameFilter?: string | null;
  statusFilter?: string | null;
  startDate?: string | null;
  endDate?: string | null;
  limit?: number;
  offset?: number;
};

export const greaseTrapFiltersState = atom<TGreaseTrapFilters>({
  key: 'greaseTrapFiltersState',
  default: {
    vendorId: null,
    vendorName: null,
    vendorNameFilter: null,
    statusFilter: null,
    startDate: dayjs().startOf('day').subtract(30, 'days').format('YYYY-MM-DD'),
    endDate: dayjs().endOf('day').format('YYYY-MM-DD'),
    limit: 10,
    offset: 0,
  },
});
